var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hub-user-avatar"},[(_vm.src)?_c('img',{staticClass:"hub-user-avatar__image",attrs:{"src":_vm.src,"alt":"user avatar"}}):_c('Icon',{attrs:{"name":"user-centered","size":24}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }